export function mapWithDefault(entity, fieldValue, defaultValue) {
  if (!entity) {
    return defaultValue;
  }
  return fieldValue();
}

export function toJs(immutableJsObj) {
  if (!immutableJsObj) {
    return {};
  }
  return immutableJsObj.toJS();
}



// WEBPACK FOOTER //
// ./app/utils/dataMapper.js